import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useTranslation } from "react-i18next";

const NetworkError = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={true}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
        },
      }}
    >
      <MDBox
        sx={{
          background: "linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)",
          py: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <MDBox
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            bgcolor: "rgba(255,255,255,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <Icon sx={{ fontSize: 38, color: "#fff" }}>wifi_off</Icon>
        </MDBox>
        <MDTypography variant="h5" fontWeight="bold" sx={{ color: "#fff" }}>
          {t("session.networkErrorTitle") || "No Connection"}
        </MDTypography>
      </MDBox>

      <DialogContent sx={{ px: 4, py: 3, textAlign: "center" }}>
        <MDTypography variant="body2" color="text" lineHeight={1.75}>
          {t("session.networkErrorMessage")}
        </MDTypography>
      </DialogContent>

      <MDBox px={4} pb={3} display="flex" gap={1.5}>
        <MDButton
          variant="outlined"
          color="secondary"
          fullWidth
          onClick={onClose}
          sx={{ borderRadius: 2 }}
        >
          {t("buttonTitles.close")}
        </MDButton>
        <MDButton
          variant="contained"
          color="info"
          fullWidth
          onClick={() => window.location.reload()}
          sx={{ borderRadius: 2 }}
          startIcon={<Icon>refresh</Icon>}
        >
          {t("buttonTitles.retry") || "Retry"}
        </MDButton>
      </MDBox>
    </Dialog>
  );
};

export default NetworkError;
